import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { VerticaTableDataset } from 'app/model/dataset/vertica.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: adfModelTypeMap.vertica.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(VerticaTableDataset) }
})
export class VerticaCopySource extends TabularCopySource {
}
